/*
  NordiskPuls - kurv-rettelser
  =================================================================
  1) Checkout-knappen der hang i "loader" efter tilbage-navigation
  2) Farvevaelger pr. stk. paa grupperede kurvlinjer OG paa gavelinjer
  3) Traeder (+/-) paa farveprodukter

  Markup'et renderes serverside i np-kurv-linjer.liquid.

  HASTIGHED - vigtigt at forstaa foer man roerer koden:
  Shopifys kurv-endpoints tager 0,5-1,8 sekund hver (MAALT 23/9-2026 paa
  produktsiden: cart/add.js 1.162-1.428 ms, cart.js 388-1.005 ms). Fire
  kald i traek bliver til fem sekunders ventetid for kunden. Derfor:

   a) Skaermen opdateres MED DET SAMME ved klik - farveskift, plus og
      minus. Serverarbejdet sker bagefter. Kunden venter aldrig paa at
      se sit eget klik.

   b) FARVESKIFT SAMLES. Skifter kunden A->B->C->D paa samme stk., er
      B og C ligegyldige: kun D skal staa i kurven til sidst. Foer
      udloeste hvert klik sit eget fjern+tilfoej (2 kald), saa fire
      klik blev til otte kald = 5-8 sekunders efterslaeb hvor kurven
      blev tegnet om under fingeren paa kunden. Nu ventes der 420 ms
      efter sidste klik, og saa koeres ALLE aendringer som eet
      fjern-pr-linje + EET samlet cart/add.js. Fire klik = 2 kald.

   c) Der fjernes FOER der tilfoejes. Shopify hasher line keys om ved
      hver aendring OG indsaetter nye varer FORREST, saa baade noegler
      og linjenumre er ugyldige efter en add. Ved at fjerne foerst kan
      vi bruge noeglen fra markup'et.

   d) Gen-tegningen foelger med i det SIDSTE kald via 'sections', og der
      tegnes kun om EEN gang pr. samling.

   e) RAEKKEFOELGEN paa stk. holdes fast af koden her, ikke af Shopify.
      Se afsnit 2b - ellers bytter raekkerne farve efter et farveskift.

   f) Ved HURTIGE KLIK tegnes der kun om efter den sidste handling.
      Se afsnit 2 - ellers hopper et stk. tilbage til sin gamle farve.

   g) "Gaa til betaling" venter til serveren har kundens farver.
      Se afsnit 6.

  HVAD SERVEREN HAR vs. HVAD SKAERMEN VISER
  Optimistisk visning betyder at unit.dataset.variantId ikke laengere er
  sandheden - den er hvad kunden lige har klikket. Serverens udgave staar
  i .np-colors[data-current], som renderes serverside. Koden her roerer
  den KUN i det oejeblik en samling sendes afsted (se samlOgSend) - saa
  betyder den "hvad serveren har, naar koeen foran er faerdig". Det er
  den vi fjerner ud fra. Bytter man den og variantId om, fjerner vi den
  farve kunden lige valgte i stedet for den han havde foer.

  /cart/update.js noeglet paa VARIANT-ID fejler TAVST (status 200, ingen
  aendring) naar en variant ligger paa to linjer - fx en gavelinje og en
  betalt linje i samme farve. Den bruges derfor kun noeglet paa LINE KEY,
  og variant-id kun for en farve der slet ikke er i kurven. Se EET KALD.
*/
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var SAMLETID = 420;   // ms efter sidste farveklik foer der sendes

  /* ============================================================
     1. CHECKOUT-KNAPPEN
     ------------------------------------------------------------
     triggerCheckout() skriver en spinner ind i knappen og saetter
     disabled = true. Trykker kunden tilbage, gendanner browseren siden
     fra sin back/forward-cache med DOM'en praecis som den var - ingen
     scripts koerer igen, saa spinneren staar der stadig og knappen er
     doed indtil kunden opdaterer. pageshow fyrer OGSAA ved den
     gendannelse. Derfor virker det her.
     ============================================================ */

  var checkoutLabel = null;

  function huskLabel() {
    var btn = document.getElementById('CartDrawer-Checkout');
    if (btn && !btn.querySelector('.checkout-spinner')) {
      var t = btn.textContent.trim();
      if (t) checkoutLabel = t;
    }
  }

  function nulstilCheckoutKnap() {
    var btn = document.getElementById('CartDrawer-Checkout');
    if (!btn) return;
    if (btn.querySelector('.checkout-spinner')) {
      btn.textContent = checkoutLabel || 'Ga naar veilige betaling';
      btn.style.opacity = '';
      btn.disabled = false;
    }
    var form = document.getElementById('CartDrawer-Form');
    if (form) form.querySelectorAll('input[name="checkout"]').forEach(function (i) { i.remove(); });
  }

  huskLabel();
  window.addEventListener('pageshow', function () { huskLabel(); nulstilCheckoutKnap(); });
  document.addEventListener('cart:updated', huskLabel);

  /* ============================================================
     2. KURV-HJAELPERE
     ============================================================ */

  function post(path, body) {
    return fetch(ROOT + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok) throw new Error(d.description || d.message || 'Kurv-fejl');
        return d;
      });
    });
  }

  function hentKurv() {
    return fetch(ROOT + 'cart.js').then(function (r) { return r.json(); });
  }

  function tegnKurvOm(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var inder = document.querySelector('.drawer__inner');
    var nyInder = doc.querySelector('.drawer__inner');
    if (inder && nyInder) inder.innerHTML = nyInder.innerHTML;
    ['cart-drawer', 'cart-drawer-items'].forEach(function (sel) {
      var nu = document.querySelector(sel), ny = doc.querySelector(sel);
      if (nu && ny) nu.classList.toggle('is-empty', ny.classList.contains('is-empty'));
    });
    domForaeldet = false;
    ordneAlle();   // foer cart:updated, saa andre lyttere ser den rigtige raekkefoelge
    if (betalingVenter) visBetalingVenter();   // ny knap i det nye markup - se afsnit 6
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  function brugSvar(data) {
    if (data && data.sections && data.sections['cart-drawer']) {
      tegnKurvOm(data.sections['cart-drawer']);
      return Promise.resolve();
    }
    return gentegn();
  }

  function gentegn() {
    return fetch(ROOT + 'cart?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (s) { s['cart-drawer'] ? tegnKurvOm(s['cart-drawer']) : location.reload(); })
      .catch(function () { location.reload(); });
  }

  function antalFraKey(lineKey) {
    var u = document.querySelector('.np-unit[data-line-key="' + lineKey + '"]');
    return u ? (parseInt(u.dataset.lineQty, 10) || 1) : 1;
  }

  // Serveren' udgave af hvilken farve dette stk. har. Se hovedkommentaren.
  function serverVariant(unit) {
    var c = unit.querySelector('.np-colors');
    var v = c && parseInt(c.dataset.current, 10);
    return v || parseInt(unit.dataset.variantId, 10);
  }

  // Serielt, saa to hurtige klik ikke traeder paa hinanden. Kunden
  // blokeres ikke - skaermen er allerede opdateret.
  var koe = Promise.resolve();
  var iGang = 0;           // handlinger i koeen, inkl. den der koerer nu
  function iKoe(fn) {
    iGang++;
    koe = koe.then(fn).catch(function (err) {
      console.error('[NP] kurv-handling mislykkedes:', err);
      return gentegn();
    }).then(function () { iGang--; });
    return koe;
  }

  /* ------------------------------------------------------------
     HURTIGE KLIK - tegn kun om efter den SIDSTE handling
     ------------------------------------------------------------
     Klikker kunden stk. 1 og saa stk. 2 med et halvt sekunds
     mellemrum, bliver det til to samlinger i koeen. Svaret paa den
     FOERSTE indeholder en kurv hvor det andet klik endnu ikke er
     sendt - tegnes den, springer stk. 2 tilbage til sin gamle farve i
     2-3 sekunder, og miniaturen mister kundens valg. (Set paa video
     25/9-2026.)

     Derfor: er der mere paa vej (flere handlinger i koeen, eller klik
     der venter paa at blive samlet), tegnes der IKKE om. Skaermen viser
     allerede det kunden har valgt. Kun den sidste handling tegner.

     Prisen: DOM'ens line keys og antal er nu foraeldede
     (domForaeldet). Saa laenge det gaelder, finder fjernStk linjen i
     en frisk /cart.js i stedet for i markup'et - ellers kunne vi saette
     antal ud fra et gammelt tal og fjerne for mange stk. Det koster eet
     ekstra kald, men kun ved hurtige klik.
     ------------------------------------------------------------ */
  var domForaeldet = false;

  function mereVenter() {
    return iGang > 1 || !!(ventende && Object.keys(ventende).length);
  }

  // Afslutter en handling i koeen: tegn om - eller lad vaere, hvis mere er paa vej
  function afslut(data) {
    if (mereVenter()) { domForaeldet = true; return Promise.resolve(); }
    if (data) return brugSvar(data);
    // Uden svar skal kurven hentes - og det tager tid. Klikker kunden
    // imens, er det hentede allerede forkert, naar det kommer frem. Saa
    // tjekkes der igen FOER der tegnes.
    return fetch(ROOT + 'cart?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        if (mereVenter()) { domForaeldet = true; return; }
        if (s['cart-drawer']) tegnKurvOm(s['cart-drawer']); else location.reload();
      })
      .catch(function () { location.reload(); });
  }

  /* ============================================================
     2b. RAEKKEFOELGEN PAA STK.
     ------------------------------------------------------------
     np-kurv-linjer.liquid tegner raekkerne i Shopifys linje-
     raekkefoelge, og cart/add.js laegger en NY linje FORREST. Skifter
     kunden stk. 2 fra groen til lilla, bliver lilla derfor linje 1 - og
     efter gen-tegningen ser det ud som om BEGGE raekker har skiftet
     farve: stk. 1 er nu lilla, stk. 2 har faaet den farve stk. 1 havde.
     Samme spring sker med plus (den nye farve hopper op som stk. 1).

     Shopifys raekkefoelge kan ikke styres uden at splitte linjerne med
     en skjult property - og saa kan to stk. i samme farve ikke laengere
     dele linje. I stedet huskes den raekkefoelge kunden SAA (variant-id
     pr. raekke, pr. produkt), og raekkerne sorteres tilbage efter HVER
     gen-tegning - uanset hvilket script der tegnede om (her, gave-
     motoren, upsell'en, temaets egen kurv).

     Gemmes i sessionStorage, saa den holder efter sideskift. Passer den
     gemte liste ikke med kurven (aendret et andet sted, fx fra
     produktsiden), bruges det der matcher, resten saettes bagerst i
     Shopifys raekkefoelge, og listen rettes til.

     Kurvens INDHOLD roeres ikke her - kun hvilken raekke der staar hvor.
     ============================================================ */

  var RK_NOEGLE = 'np-kurv-raekkefoelge';
  var raekkefoelge = {};
  try { raekkefoelge = JSON.parse(sessionStorage.getItem(RK_NOEGLE)) || {}; } catch (e) { raekkefoelge = {}; }

  function gemRaekkefoelge() {
    try { sessionStorage.setItem(RK_NOEGLE, JSON.stringify(raekkefoelge)); } catch (e) {}
  }

  // Sidst klikkede farve pr. produkt - styrer miniaturen (se ordneGruppe)
  var MI_NOEGLE = 'np-kurv-miniature';
  var miniature = {};
  try { miniature = JSON.parse(sessionStorage.getItem(MI_NOEGLE)) || {}; } catch (e) { miniature = {}; }

  function gemMiniature() {
    try { sessionStorage.setItem(MI_NOEGLE, JSON.stringify(miniature)); } catch (e) {}
  }

  // Raekker skjult af minus (venter paa serveren) taeller ikke med
  function synligeUnits(gruppe) {
    return [].slice.call(gruppe.querySelectorAll('.np-unit')).filter(function (u) {
      return u.style.display !== 'none';
    });
  }

  // Kaldes efter hvert klik, naar skaermen viser det kunden vil have
  function huskRaekkefoelge(gruppe) {
    if (!gruppe || gruppe.dataset.gave === 'true') return;
    var pid = gruppe.dataset.productId;
    if (!pid) return;
    raekkefoelge[pid] = synligeUnits(gruppe).map(function (u) { return u.dataset.variantId; });
    gemRaekkefoelge();
  }

  function ordneGruppe(gruppe) {
    var pid = gruppe.dataset.productId;
    var boks = gruppe.querySelector('.np-units');
    if (!pid || !boks) return;

    var units = synligeUnits(gruppe);
    var oensket = raekkefoelge[pid] || [];
    var rest = units.slice();
    var ny = [];
    oensket.forEach(function (vid) {
      for (var i = 0; i < rest.length; i++) {
        if (rest[i].dataset.variantId === String(vid)) { ny.push(rest.splice(i, 1)[0]); return; }
      }
    });
    ny = ny.concat(rest);   // nye stk. som listen ikke kendte, i Shopifys raekkefoelge

    var flyttes = ny.some(function (u, i) { return u !== units[i]; });
    if (flyttes) {
      ny.forEach(function (u) { boks.appendChild(u); });

      // Traederen hoerer til raekke 1 - flyt den med
      var stepper = gruppe.querySelector('.np-stepper');
      if (stepper && stepper.parentNode !== ny[0]) ny[0].appendChild(stepper);

      ny.forEach(function (u, i) {
        var nr = u.querySelector('.np-unit__nr');
        if (nr) nr.textContent = i + 1;
      });

    }

    // Miniaturen: serveren saetter den efter Shopifys linje 1. Den skal
    // vise den farve kunden SIDST klikkede - saa laenge den stadig er i
    // gruppen. Ellers raekke 1.
    var img = gruppe.querySelector('.cart-item__image');
    if (img && ny.length) {
      var vis = null;
      var sidst = miniature[pid];
      if (sidst && ny.some(function (u) { return u.dataset.variantId === String(sidst); })) {
        vis = gruppe.querySelector('.np-color[data-variant-id="' + sidst + '"]');
      } else if (sidst && !mereVenter()) {
        delete miniature[pid];   // kun naar kurven er faerdig - ellers er det bare et mellemtrin
        gemMiniature();
      }
      if (!vis) vis = ny[0].querySelector('.np-color.is-active');
      var src = vis && vis.dataset.image;
      if (src && img.getAttribute('src') !== src) img.src = src;
    }

    // Listen rettes kun til naar kurven er faerdig. Midt i en serie klik
    // er det kundens liste der er sandheden, ikke et mellemtrin.
    var liste = ny.map(function (u) { return u.dataset.variantId; });
    if (!mereVenter() && JSON.stringify(liste) !== JSON.stringify(raekkefoelge[pid])) {
      raekkefoelge[pid] = liste;
      gemRaekkefoelge();
    }
  }

  function ordneAlle() {
    document.querySelectorAll('.np-gruppe:not([data-gave="true"])').forEach(ordneGruppe);
  }

  // Fanger gen-tegninger fra ANDRE scripts. requestAnimationFrame koerer
  // foer naeste paint, saa kunden ser aldrig den ombyttede udgave.
  // ordneGruppe flytter kun noget naar raekkefoelgen er forkert, saa den
  // kan ikke starte en loekke med sig selv.
  var ordneVenter = false;
  function planlaegOrdning() {
    if (ordneVenter) return;
    ordneVenter = true;
    requestAnimationFrame(function () { ordneVenter = false; ordneAlle(); });
  }
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].addedNodes.length) { planlaegOrdning(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ordneAlle);
  } else {
    ordneAlle();
  }

  /* ============================================================
     3. FARVESKIFT - samlet
     ------------------------------------------------------------
     'ventende' holder een post pr. stk. kunden har roert. 'fra' er hvad
     serveren har, 'til' er hvad kunden sidst klikkede. Klikker han igen
     paa samme stk., opdateres kun 'til' - der laegges ikke en ekstra
     opgave i koeen. Ender han tilbage hvor han startede (fra === til),
     droppes opgaven helt og der sendes ingenting.
     ============================================================ */

  var ventende = {};       // token -> opgave
  var naesteToken = 1;
  var samleUr = null;

  function planlaegSamling() {
    clearTimeout(samleUr);
    samleUr = setTimeout(samlOgSend, SAMLETID);
  }

  function skiftFarve(unit, knap) {
    var nyId = parseInt(knap.dataset.variantId, 10);
    if (!nyId || nyId === parseInt(unit.dataset.variantId, 10)) return;

    // En raekke der endnu ikke findes paa serveren (lige tilfoejet med +)
    // har ingen line key. Den kan ikke skiftes foer den er landet.
    var lineKey = unit.dataset.lineKey;
    if (!lineKey) return;

    var gruppe = unit.closest('.np-gruppe');
    var erGave = gruppe ? gruppe.dataset.gave === 'true' : false;

    /* --- OEJEBLIKKELIG visning: ringen flyttes og billedet skiftes nu --- */
    unit.querySelectorAll('.np-color').forEach(function (b) { b.classList.remove('is-active'); });
    knap.classList.add('is-active');
    unit.dataset.variantId = nyId;
    unit.classList.add('np-venter');
    // Miniaturen viser den senest klikkede farve - ogsaa efter gen-tegning
    var img = gruppe && gruppe.querySelector('.cart-item__image');
    if (img && knap.dataset.image) img.src = knap.dataset.image;
    if (gruppe && !erGave && gruppe.dataset.productId) {
      miniature[gruppe.dataset.productId] = String(nyId);
      gemMiniature();
    }
    huskRaekkefoelge(gruppe);

    if (!unit.dataset.npToken) unit.dataset.npToken = 'u' + (naesteToken++);
    var t = unit.dataset.npToken;

    if (ventende[t]) {
      ventende[t].til = nyId;
    } else {
      ventende[t] = {
        unit: unit,
        lineKey: lineKey,
        fra: serverVariant(unit),
        til: nyId,
        erGave: erGave,
        gavetype: gruppe ? gruppe.dataset.gavetype : null
      };
    }
    planlaegSamling();
  }

  // Fjerner N stk. af en kurvlinje. Proever foerst noeglen fra markup'et
  // (eet kald). Er den blevet ugyldig, fordi kurven har aendret sig siden
  // sidste rendering, hentes den friske noegle og der proeves igen.
  function fjernStk(o) {
    if (domForaeldet) return viaKurven(o);   // markup'ets antal kan vaere forkert - se HURTIGE KLIK
    // Noeglen blev laest ved klikket. Er kurven tegnet om siden, kan den
    // tilhoere en anden farve (fx naar to stk. har byttet). En line key
    // starter med variant-id'et, saa det kan tjekkes uden et kald.
    if (variantFraKey(o.lineKey) !== o.variant) return viaKurven(o);
    var kendt = !!document.querySelector('.np-unit[data-line-key="' + o.lineKey + '"]');
    if (kendt) {
      return post('cart/change.js', { id: o.lineKey, quantity: Math.max(0, antalFraKey(o.lineKey) - o.antal) })
        .catch(function () { return viaKurven(o); });
    }
    return viaKurven(o);
  }

  function viaKurven(o) {
    return hentKurv().then(function (cart) {
      var linje = cart.items.find(function (it) {
        return it.variant_id === o.variant &&
               !!(it.properties && it.properties._is_gift) === !!o.erGave;
      });
      if (!linje) throw new Error('fandt ikke linjen igen');
      return post('cart/change.js', { id: linje.key, quantity: Math.max(0, linje.quantity - o.antal) });
    });
  }

  function samlOgSend() {
    var alle = Object.keys(ventende).map(function (k) { return ventende[k]; });
    ventende = {};
    var opgaver = alle.filter(function (o) { return o.fra !== o.til; });
    if (!opgaver.length) {
      // Kunden endte hvor han startede. Blev en tidligere gen-tegning
      // sprunget over, er der stadig brug for een til sidst.
      if (domForaeldet) iKoe(function () { return afslut(null); });
      return;
    }

    // Koeen koerer serielt, saa naar DENNE samling kommer frem, har
    // serveren 'til'. Det skrives paa stk. nu, saa et nyt klik paa samme
    // stk. mens vi venter fjerner den rigtige farve (og ikke den gamle).
    opgaver.forEach(function (o) {
      var c = o.unit && o.unit.isConnected && o.unit.querySelector('.np-colors');
      if (c) c.dataset.current = o.til;
    });

    var rammerGave = opgaver.some(function (o) { return o.erGave; });

    // Flere stk. i samme farve deler EEN kurvlinje. Saetter vi qty ned to
    // gange uafhaengigt, laeser begge kald det samme "2" i markup'et og
    // skriver begge "1" - saa forsvinder kun det ene stk. Derfor taelles
    // de sammen pr. linje foerst.
    // Samles pr. FARVE (+ gave/ikke gave), ikke pr. noegle: to stk. fra
    // samme linje kan have faaet hver sin 'fra', hvis det ene er skiftet
    // tidligere i en serie klik.
    var fjernes = {};
    opgaver.forEach(function (o) {
      var id = o.fra + '|' + (o.erGave ? 'g' : 'b');
      var f = fjernes[id];
      if (f) { f.antal++; return; }
      fjernes[id] = { lineKey: o.lineKey, antal: 1, variant: o.fra, erGave: o.erGave };
    });

    var nye = opgaver.map(function (o) {
      var it = { id: o.til, quantity: 1 };
      if (o.erGave) {
        it.properties = { _is_gift: 'true' };
        if (o.gavetype) it.properties._gavetype = o.gavetype;
      }
      return it;
    });

    // Gavemotoren maa ikke naa at se det oejeblik hvor gaven er fjernet
    // og den nye farve endnu ikke lagt i - saa ville den lagge en gave
    // nummer to i kurven.
    if (rammerGave) { window.isProcessingGift = true; window.npGaveLaas = true; }

    // Den gamle vej: fjern pr. linje, saa eet samlet cart/add.js. Bruges
    // til gavelinjer (se EET KALD nedenfor) og som noedudgang.
    function toKald() {
      var kaede = Promise.resolve();
      Object.keys(fjernes).forEach(function (k) {
        kaede = kaede
          .then(function () { return fjernStk(fjernes[k]); })
          // MAALT 25/9: naar en linje fjernes, giver Shopify de ANDRE linjer
          // nye noegler. Naeste fjernelse med markup'ets noegle faar 400
          // ("ingen gyldige id eller linjeparametre") og koster et helt
          // kald (1,2 s) foer den falder tilbage. Saa slaa op med det samme.
          .then(function () { domForaeldet = true; });
      });
      return kaede
        .then(function () { return post('cart/add.js', { items: nye, sections: 'cart-drawer' }); })
        .then(afslut);
    }

    iKoe(function () {
      var vej = rammerGave
        ? toKald()
        : eetKald(opgaver).then(function (data) {
            if (!data) return toKald();
            if (data.ingen) {
              // Serveren er rigtig, men raekkernes line keys peger nu paa
              // hinandens linjer (data-current er byttet, noeglerne ikke).
              // Marker markup'et som foraeldet, saa minus/farveskift slaar
              // op paa varianten - og tegn om hvis intet andet er paa vej.
              domForaeldet = true;
              return afslut(null);
            }
            return afslut(data);
          });
      return vej.finally(function () {
        if (rammerGave) { window.isProcessingGift = false; window.npGaveLaas = false; }
      });
    });
  }

  /* ------------------------------------------------------------
     EET KALD - farveskift paa betalte linjer via cart/update.js
     ------------------------------------------------------------
     MAALT 25/9-2026 i preview af 7.4 (5 gange, median):
       cart/change.js         1.239 ms  \  i alt 2.460 ms for eet
       cart/add.js+sections   1.221 ms  /  farveskift
       cart/update.js+sect.   1.114 ms  <- det samme i EET kald
       cart.js                  319 ms

     update.js tager 'updates' noeglet paa LINE KEY (praecis linje) eller
     variant-id (kun til en farve der ikke ligger i kurven i forvejen).
     Advarslen i toppen af filen om at update.js fejler tavst gaelder
     variant-id paa en variant der ligger paa TO linjer. Den undgaas her:
       - eksisterende linjer rammes altid via line key
       - variant-id bruges kun naar farven slet ikke findes i kurven -
         heller ikke paa en gavelinje. Findes den kun som gave, bruges
         den gamle vej.
     En line key der ikke findes giver 422 (MAALT: "Cannot find
     variant"), og saa er INTET aendret - heller ikke de andre linjer i
     samme kald (MAALT). Saa falder vi tilbage til den gamle vej, som
     selv slaar linjerne op igen.

     OBS: en key kan godt overleve at linjens antal aendres (MAALT). Det
     farlige er derfor ikke en gammel key, men et gammelt ANTAL - update.js
     saetter antallet absolut. Derfor bruges markup'ets tal kun naar det
     er friskt (domForaeldet === false); ellers hentes /cart.js.

     Gavelinjer koerer ALTID den gamle vej: update.js kan ikke saette
     _is_gift/_gavetype paa en ny linje.

     Returnerer svaret fra update.js, { ingen: true } hvis der netto
     ikke er noget at aendre, eller null = brug den gamle vej.
     ------------------------------------------------------------ */
  function variantFraKey(key) {
    var v = parseInt(String(key).split(':')[0], 10);
    return v > 0 ? v : 0;
  }

  /* ------------------------------------------------------------
     INTELLIGEMS - tilbud og pristests skal have den gamle vej
     ------------------------------------------------------------
     Intelligems (A/B-tests) lapper window.fetch. MAALT 25/9 i preview:
       - efter cart/change.js kalder den getCart() -> validateCart(): saetter
         igId, skriver test-tilknytning (cart metafields) og haandhaever
         tilbud/testpriser.
       - efter cart/update.js goer den det KUN naar et tilbud/bundle er
         aktivt (SHOULD_MODIFY_VD_REQUESTS). Ellers intet.
       - et almindeligt GET /cart.js udloeser samme validateCart.
       - ved tilbud/bundle/pristest AENDRER den udgaaende cart/add.js
         (_modifyLineItemOutbound: egenskaber, alternative varianter).
         Det kan den ikke med update.js.
     Derfor: intelligemsRoerer(). Er der tilbud, kampagner, GWP eller en
     pristest paa en af farverne, bruges den gamle vej (change + add), som
     Intelligems understoetter fuldt ud - saa prisen bliver rigtig.
     Ellers update.js, og Intelligems ser ikke farveskiftet. Det er valgt
     (Andreas 25/9): test-tilknytningen (igId + metafields) saettes ved
     laeg-i-kurv paa produktsiden, og et farveskift aendrer ikke hvilken
     testgruppe kunden er i. Vil man have at Intelligems ogsaa SER
     farveskift uden aktive tilbud: et GET /cart.js gennem window.fetch
     efter update.js udloeser validateCart (MAALT, ca. 0,3 s).
     window.igData er Intelligems' offentlige API (offers.getAll,
     campaigns.getAll, price.getAltVariantId/getDiscountByVariantId -
     alle synkrone, MAALT). Kaster det, vaelges den gamle vej.
     ------------------------------------------------------------ */
  function intelligemsRoerer(varianter) {
    var ig = window.igData;
    if (!ig) return false;
    try {
      var liste = function (o, f) { var r = o && typeof o[f] === 'function' ? o[f]() : []; return (r && r.length) || 0; };
      if (liste(ig.offers, 'getAll') || liste(ig.offers, 'getGWP') || liste(ig.campaigns, 'getAll')) return true;
      var p = ig.price;
      if (p) {
        for (var i = 0; i < varianter.length; i++) {
          var v = varianter[i];
          var alt = typeof p.getAltVariantId === 'function' ? p.getAltVariantId(v) : null;
          if (alt && String(alt) !== String(v)) return true;
          if (typeof p.getDiscountByVariantId === 'function' && p.getDiscountByVariantId(v)) return true;
        }
      }
      return false;
    } catch (e) {
      return true;
    }
  }

  // Kurvens betalte linjer som { variant: {key, antal} }, plus hvilke
  // varianter der ligger som gave. Fra markup'et hvis det er friskt,
  // ellers fra /cart.js.
  function hentLinjer() {
    if (!domForaeldet) {
      var betalt = {}, gave = {}, ok = true;
      document.querySelectorAll('.np-gruppe .np-unit[data-line-key]').forEach(function (u) {
        var key = u.dataset.lineKey, v = variantFraKey(key);
        if (!v) { ok = false; return; }
        var g = u.closest('.np-gruppe');
        if (g && g.dataset.gave === 'true') { gave[v] = true; return; }
        betalt[v] = { key: key, antal: parseInt(u.dataset.lineQty, 10) || 1 };
      });
      // Naesestrips-gaven og andre linjer uden farvevaelger staar ikke som
      // .np-unit, men de er andre produkter end farvevarerne - ingen kollision.
      return Promise.resolve(ok ? { betalt: betalt, gave: gave } : null);
    }
    return hentKurv().then(function (cart) {
      var betalt = {}, gave = {};
      cart.items.forEach(function (it) {
        if (it.properties && it.properties._is_gift) { gave[it.variant_id] = true; return; }
        if (betalt[it.variant_id]) { betalt.__dobbelt = true; return; }   // samme farve paa to betalte linjer
        betalt[it.variant_id] = { key: it.key, antal: it.quantity };
      });
      return betalt.__dobbelt ? null : { betalt: betalt, gave: gave };
    });
  }

  function eetKald(opgaver) {
    var varianter = [];
    opgaver.forEach(function (o) { varianter.push(o.fra, o.til); });
    if (intelligemsRoerer(varianter)) return Promise.resolve(null);   // gammel vej - se INTELLIGEMS
    return hentLinjer().then(function (l) {
      if (!l) return null;
      var antal = {};                       // variant -> nyt antal
      Object.keys(l.betalt).forEach(function (v) { antal[v] = l.betalt[v].antal; });
      for (var i = 0; i < opgaver.length; i++) {
        var o = opgaver[i];
        if (!antal[o.fra]) return null;     // kender ikke linjen - gammel vej
        antal[o.fra]--;
        if (!l.betalt[o.til] && l.gave[o.til]) return null;   // farven findes kun som gave
        antal[o.til] = (antal[o.til] || 0) + 1;
      }
      var updates = {}, noget = false;
      Object.keys(antal).forEach(function (v) {
        var eks = l.betalt[v];
        if (eks && eks.antal === antal[v]) return;           // uaendret
        if (eks) updates[eks.key] = antal[v];
        else if (antal[v] > 0) updates[v] = antal[v];
        noget = true;
      });
      // Klikkene gik ud med hinanden (fx to stk. der byttede farve): kurven
      // er allerede rigtig. Intet at sende.
      if (!noget) return { ingen: true };
      return post('cart/update.js', { updates: updates, sections: 'cart-drawer' })
        .catch(function (e) {
          console.warn('[NP] update.js afvist, bruger to kald:', e.message);
          domForaeldet = true;              // noeglerne passede ikke - slaa op paa ny
          return null;
        });
    });
  }

  /* ============================================================
     4. TRAEDEREN
     ============================================================ */

  // Plus: en raekke mere, i den foerste farve kunden IKKE allerede har.
  // Typisk vil man have forskellige farver - ellers skifter man bare
  // den nye tilbage.
  //
  // Farverne staar ALLEREDE i markup'et som .np-color-knapper med
  // data-variant-id og disabled paa de udsolgte. Foer hentede vi
  // /products/<handle>.js foerst for at finde dem - 300-500 ms hvor der
  // ikke skete noget som helst paa skaermen. Der er ingen grund til at
  // spoerge serveren om noget vi allerede har staaende.
  function tilfoejEn(gruppe) {
    var units = [].slice.call(gruppe.querySelectorAll('.np-unit'));
    if (!units.length) return;
    var sidste = units[units.length - 1];
    var brugte = units.map(function (u) { return parseInt(u.dataset.variantId, 10); });

    var ledige = [].slice.call(sidste.querySelectorAll('.np-color')).filter(function (b) {
      return !b.disabled && !b.classList.contains('is-sold-out');
    });
    if (!ledige.length) return;
    var valgt = ledige.find(function (b) {
      return brugte.indexOf(parseInt(b.dataset.variantId, 10)) === -1;
    }) || ledige[0];
    var valgtId = parseInt(valgt.dataset.variantId, 10);

    /* --- OEJEBLIKKELIG visning: raekken og tallet er der nu --- */
    var kopi = sidste.cloneNode(true);
    kopi.removeAttribute('data-line-key');      // findes ikke paa serveren endnu
    kopi.removeAttribute('data-np-token');
    kopi.dataset.variantId = valgtId;
    var nr = kopi.querySelector('.np-unit__nr');
    if (nr) nr.textContent = units.length + 1;
    var st = kopi.querySelector('.np-stepper');
    if (st) st.remove();                         // traederen staar kun paa raekke 1
    var farver = kopi.querySelector('.np-colors');
    if (farver) farver.dataset.current = valgtId;
    kopi.querySelectorAll('.np-color').forEach(function (b) {
      b.classList.toggle('is-active', parseInt(b.dataset.variantId, 10) === valgtId);
    });
    kopi.classList.add('np-venter');
    sidste.parentNode.appendChild(kopi);
    huskRaekkefoelge(gruppe);                    // den nye raekke skal blive nederst

    var tal = gruppe.querySelector('.np-stepper__tal');
    if (tal) tal.textContent = (parseInt(tal.textContent, 10) || units.length) + 1;
    var minus = gruppe.querySelector('.np-minus');
    if (minus) minus.disabled = false;

    iKoe(function () {
      return post('cart/add.js', { items: [{ id: valgtId, quantity: 1 }], sections: 'cart-drawer' })
        .then(afslut)
        .catch(function (e) {
          if (kopi.parentNode) kopi.remove();    // rul den optimistiske raekke tilbage
          huskRaekkefoelge(gruppe);
          throw e;
        });
    });
  }

  // Minus: fjern den nederste raekke
  function fjernEn(gruppe) {
    var units = gruppe.querySelectorAll('.np-unit');
    if (units.length < 2) return;             // sidste stk. fjernes med skraldespanden
    var sidste = units[units.length - 1];
    var key = sidste.dataset.lineKey;
    if (!key) return;                          // raekke der endnu ikke er landet
    var vid = serverVariant(sidste);
    var erGave = gruppe.dataset.gave === 'true';

    /* --- OEJEBLIKKELIG visning --- */
    sidste.style.display = 'none';
    huskRaekkefoelge(gruppe);
    var tal = gruppe.querySelector('.np-stepper__tal');
    if (tal) tal.textContent = Math.max(1, (parseInt(tal.textContent, 10) || units.length) - 1);
    var minus = gruppe.querySelector('.np-minus');
    if (minus && units.length - 1 <= 1) minus.disabled = true;

    iKoe(function () {
      return fjernStk({ lineKey: key, antal: 1, variant: vid, erGave: erGave })
        .then(function () { return afslut(null); })
        .catch(function (e) { sidste.style.display = ''; huskRaekkefoelge(gruppe); throw e; });
    });
  }

  // Skraldespand: hele gruppen ud, alle farver
  function fjernGruppe(gruppe) {
    var pid = parseInt(gruppe.dataset.productId, 10);
    gruppe.style.opacity = '0.35';
    gruppe.style.pointerEvents = 'none';
    iKoe(function () {
      function naeste() {
        return hentKurv().then(function (cart) {
          var linje = cart.items.find(function (it) {
            return it.product_id === pid && !(it.properties && it.properties._is_gift);
          });
          if (!linje) return afslut(null);
          return post('cart/change.js', { id: linje.key, quantity: 0 }).then(naeste);
        });
      }
      return naeste();
    });
  }

  /* ============================================================
     6. BETALINGSKNAPPEN VENTER PAA KURVEN
     ------------------------------------------------------------
     Skaermen viser kundens farver MED DET SAMME, men serveren faar dem
     foerst 1-2 sek. senere (420 ms samling + ca. 1,1 s update.js).
     Trykkede kunden "Gaa til betaling" i det vindue, tog checkout den
     farve serveren havde - altsaa den forrige. (Set af Andreas 25/9.)

     Derfor fanges klikket i CAPTURE-fasen, foer det naar knappens egen
     onclick (window.triggerCheckout i np-cart-drawer-logic.js):
       - Er intet i gang: klikket fortsaetter uroert, praecis som foer.
       - Er noget i gang: knappen viser spinneren, ventende klik sendes
         MED DET SAMME (ingen 420 ms), og naar koeen er tom, kaldes
         triggerCheckout(). Kunden trykker kun een gang.
     Aldrig mere end 10 sek. - hellere en checkout med en forkert farve
     end en knap der ikke virker.

     window.isProcessingGift er naesestrips-motoren (np-cart-drawer-
     logic.js). Den ventes der ogsaa paa, saa gaven er med i checkout.
     ============================================================ */

  var betalingVenter = false;
  var MAKS_VENT = 10000;

  function kurvTravl() {
    return iGang > 0 || Object.keys(ventende).length > 0 || !!window.isProcessingGift;
  }

  function visBetalingVenter() {
    var btn = document.getElementById('CartDrawer-Checkout');
    if (!btn || btn.querySelector('.checkout-spinner')) return;
    btn.innerHTML = '<span class="checkout-spinner"></span>';
    btn.style.opacity = '0.8';
    btn.setAttribute('aria-busy', 'true');
  }

  function kurvKlar() {
    return new Promise(function (faerdig) {
      var slut = Date.now() + MAKS_VENT;
      (function tjek() {
        if (Object.keys(ventende).length) { clearTimeout(samleUr); samlOgSend(); }
        if (!kurvTravl() || Date.now() > slut) return faerdig();
        setTimeout(tjek, 60);
      })();
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#CartDrawer-Checkout');
    if (!btn || btn.disabled) return;
    if (!betalingVenter && !kurvTravl()) return;   // intet i gang - som foer

    e.preventDefault();
    e.stopPropagation();          // naar aldrig knappens onclick
    e.stopImmediatePropagation();
    if (betalingVenter) return;   // allerede paa vej - ignorer ekstra tryk

    betalingVenter = true;
    huskLabel();
    visBetalingVenter();
    kurvKlar().then(function () {
      betalingVenter = false;
      if (typeof window.triggerCheckout === 'function') { window.triggerCheckout(); return; }
      var form = document.getElementById('CartDrawer-Form');
      if (form) {
        var i = document.createElement('input');
        i.type = 'hidden'; i.name = 'checkout'; i.value = 'Checkout';
        form.appendChild(i);
        form.submit();
      }
    });
  }, true);

  /* ============================================================
     5. KLIK - delegeret, saa det overlever gen-rendering
     ============================================================ */

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var farve = e.target.closest('.np-color');
    if (farve) {
      if (farve.disabled || farve.classList.contains('is-active')) return;
      var unit = farve.closest('.np-unit');
      if (!unit) return;
      e.preventDefault(); e.stopPropagation();
      skiftFarve(unit, farve);
      return;
    }

    var plus = e.target.closest('.np-plus');
    if (plus) { e.preventDefault(); e.stopPropagation(); tilfoejEn(plus.closest('.np-gruppe')); return; }

    var minus = e.target.closest('.np-minus');
    if (minus) {
      if (minus.disabled) return;
      e.preventDefault(); e.stopPropagation(); fjernEn(minus.closest('.np-gruppe')); return;
    }

    // Gavens egen skraldespand haandteres i np-gavemotor.js, fordi den
    // ogsaa skal huske at kunden har fravalgt gaven.
    var skrald = e.target.closest('.np-fjern-gruppe');
    if (skrald) { e.preventDefault(); e.stopPropagation(); fjernGruppe(skrald.closest('.np-gruppe')); return; }
  });

  // Tegnes kurven om af en ANDEN grund (gavemotoren lagger gaven i,
  // upsell'en tilfoejer noget), forsvinder de line keys vi har samlet op.
  // Klikket maa ikke bare droppes - saa ville kundens farvevalg hoppe
  // tilbage. Vi sender det derfor med det samme; fjernStk finder linjen
  // paa varianten i stedet for paa noeglen.
  document.addEventListener('cart:updated', function () {
    clearTimeout(samleUr);
    samlOgSend();
  });
})();
